import jQuery from 'jquery'
import React from 'react'
import { App, ConfigContext, sessionUtility } from 'acss-mvo-ts-components'
// import { App, ConfigContext, sessionUtility } from '../../ts-components/index'
import useAdditionalInfo from '../hooks/useAdditionalInfo'
import { Box } from '../components/Flexify'
import { getProps } from '../helpers/troubleshootingProps'
import { init } from '../helpers/init'
import { getConfig } from '../helpers/config'
import { Loader } from '@vds/loaders'
import { library } from '@vz/react-util'

window.$ = jQuery
window.jQuery = jQuery

console.log('node_env', process.env.NODE_ENV)

const Troubleshooting = () => {
  const { data: additionalData, isLoading } = useAdditionalInfo()
  const { configData = {}, ddata } = additionalData || {}
  const { breadcrumb, combinedIssueSelector = false, mtns = [] } = configData
  const additionalInfoSteps = ddata?.output?.pageContent?.steps || []
  const modalError = additionalData?.success

  // initilize with existing logic
  init({ additionalMtns: mtns, combinedIssueSelector, configData })

  //Added for React util library
  library.init({ appName: 'MVO-SUPPORT', pageName: 'Troubleshooting-Digital', pageTitle: 'Troubleshooting' })

  const props = getProps({ combinedIssueSelector })
  sessionUtility.setRunMode(props.mvoenv)

  const selectedNSAIntent = {
    intent: window?.caseDetails?.intent,
    intentId: window?.caseDetails?.intentId,
    caseId: window?.caseDetails?.caseId,
  }

  const config = getConfig({ configData })

  console.log('config', config)
  console.log('additionalData', additionalData)

  if (isLoading) return null

  return (
    <ConfigContext.Provider
      value={{
        paramsDetails: props,
        config,
        selectedNSAIntent,
        caseId: selectedNSAIntent.caseId,
        breadcrumbData: breadcrumb,
        additionalMtns: mtns,
        route1MtnId: window.route1MtnId == -1 ? '' : window.route1MtnId,
      }}
    >
      <App additionalInfoSteps={additionalInfoSteps} modalError={modalError} />
    </ConfigContext.Provider>
  )
}

export default Troubleshooting
